import React from "react"

import ServiceBox from "./ServiceBox"
import style from "./index.module.sass"
import Spinner from "../../ui-components/Spinner"

// ----------------------------------------------------------------------------

function ServicesList(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------
  const { isLoading = false, venues = [], services, orderMode, onClick } = props
  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  if (isLoading) {
    return (
      <div className={style.container}>
        <div className={style.spinnerContainer}>
          <Spinner />
        </div>
      </div>
    )
  }

  return (
    <div className={style.container}>
      {services.map((s) => {
        return (
          <ServiceBox
            key={s.id}
            service={s}
            venue={venues.filter((v) => v.id === s.venue.id)[0]}
            orderMode={orderMode}
            onClick={onClick}
          />
        )
      })}
      {/* Prevent last line elements to grow without control */}
      {/* Actually the only working work-around to this flex lack */}
      <div className={style.lastCard}></div>
      <div className={style.lastCard}></div>
      <div className={style.lastCard}></div>
    </div>
  )
}

// ----------------------------------------------------------------------------

export default ServicesList
